import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subject } from 'rxjs'
import { ProgramInitiationContainerComponent } from '../program-initiation-container/program-initiation.container'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-program-initiation-route',
  templateUrl: `./program-initiation-route.container.html`,
  imports: [ProgramInitiationContainerComponent],
})
export class ProgramInitiationRouteContainerComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute)

  private destroy$ = new Subject()

  ngOnInit(): void {
    this.route.paramMap.subscribe()
  }

  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
